// extracted by mini-css-extract-plugin
module.exports = {"googleBtn":"style-module__googleBtn___1Vo2N","googleIcon":"style-module__googleIcon___+YrbD"};